import React, { Suspense, lazy } from "react";
import { Routes, Route } from "react-router-dom";
import PublicRoute from "./PublicRoute";
import HeaderContainer from "../layouts/HeaderContainer";
import ProtectedRoute from "./ProtectedRoute";
import RequestReceived from "../pages/protected-pages/request-for-free-exam/RequestReceived";
import PatronHtmlParser from "../components/PatronHtmlParser";
import ReusableLoader from "../layouts/loader/ReusableLoader";

// Lazy-loaded pages
const LandingPage = lazy(
  () => import("../pages/unprotected-pages/landing-page/LandingPage")
);
const Login = lazy(() => import("../pages/auth/Login"));
const BrowseCoursesMain = lazy(
  () => import("../pages/unprotected-pages/browse-courses/BrowseCoursesMain")
);
const Dashboard = lazy(
  () => import("../pages/protected-pages/dashboard/Dashboard")
);
const FAQ = lazy(() => import("../pages/unprotected-pages/FAQs/FAQ"));
const PastRequest = lazy(
  () => import("../pages/protected-pages/past-request/PastRequest")
);
const RequestForFreeExam = lazy(
  () =>
    import("../pages/protected-pages/request-for-free-exam/RequestForFreeExam")
);

interface AppRoutesProps {
  user: boolean;
  onLogin: () => void;
  onLogout: () => void;
}

const AppRoutes: React.FC<AppRoutesProps> = ({ user, onLogin, onLogout }) => {
  return (
    <Suspense fallback={<ReusableLoader />}>
      <Routes>
        {/* Public routes without header */}
        <Route
          element={
            <HeaderContainer
              loggedIn={user}
              onLogin={onLogin}
              onLogout={onLogout}
              // hideAuthButtons={false}
            />
          }
        >
          <Route path="/" element={<LandingPage onLogout={onLogout} />} />
        </Route>
        <Route
          path="/login"
          element={
            <PublicRoute user={user}>
              <Login onLogin={onLogin} />
            </PublicRoute>
          }
        />

        <Route
          path="/html-parser"
          element={
            // <PublicRoute user={user}>
            <PatronHtmlParser />
            // </PublicRoute>
          }
        />

        {/* Shared route without header */}
        <Route
          path="/browse-courses"
          element={
            <HeaderContainer
              loggedIn={user}
              onLogin={onLogin}
              onLogout={onLogout}
            />
          }
        >
          <Route path="/browse-courses" element={<BrowseCoursesMain />} />
        </Route>
        {/* FAQ route with header but no login/logout */}
        <Route
          element={
            <HeaderContainer
              loggedIn={user}
              onLogin={onLogin}
              onLogout={onLogout}
              // hideAuthButtons={false}
            />
          }
        >
          <Route path="/FAQ" element={<FAQ />} />
        </Route>

        {/* Protected routes with header and login/logout */}
        <Route
          element={
            <HeaderContainer
              loggedIn={user}
              onLogin={onLogin}
              onLogout={onLogout}
            />
          }
        >
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute user={user}>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/past-request"
            element={
              <ProtectedRoute user={user}>
                <PastRequest />
              </ProtectedRoute>
            }
          />
          <Route
            path="/request-for-free-exam"
            element={
              <ProtectedRoute user={user}>
                <RequestForFreeExam />
              </ProtectedRoute>
            }
          />
          <Route
            path="/request-received"
            element={
              <ProtectedRoute user={user}>
                <RequestReceived />
              </ProtectedRoute>
            }
          />
        </Route>
      </Routes>
    </Suspense>
  );
};

export default AppRoutes;
